export default __webpack_public_path__ + "static/media/200_ml.bc2d88ab.svg";